import styled from 'styled-components';

const Wrapper = styled.div`
    display: flex;
    align-items: center;
    padding: 4px 8px;
    gap: 4px;
    min-width: 65px;
    height: 26px;
    background: ${(props) => props.theme.colors.surface_muted};
    border-radius: 6px;
    cursor: pointer;

  p {
      font-style: normal;
      font-weight: 500;
      font-size: 13px;
      min-width: 20px;
      text-align: center;
      color: ${(props) => props.theme.colors.text};
    }
  
  &:hover .arrowDown{
    margin-top: 4px;
    transition: all .2s ease-in;
  }

  &:hover p{
    color: ${(props) => props.theme.colors.hover_accent};
    transition: all .2s ease-in;
  }
`;

export default { Wrapper };
